import React from "react";
import Seo from '../components/common/Seo';
import silder_2 from "../assets/styles/slider_2.png";
import AboutHero from '../components/about/AboutHero';
import ContactInfo from "../components/contact/ContactInfo";
import ContactForm from "../components/contact/ContactForm";
import MapSection from "../components/contact/MapSection";

const Contact = () => {
    return (
        <div>
          <Seo
            title="Contact Agastya Agro Limited | Sales, Support & Partnerships"
            description="Talk to Agastya Agro for product guidance, dealership support, partnerships, or bulk enquiries. Our team is ready to help quickly."
          />
          <AboutHero 
            heroImage={silder_2}
            title="Contact Us"
            subtitle="Contact Us"
          />

          {/* ContactInfo */}
          <ContactInfo />

          {/* ContactForm */}
          <ContactForm />
        
          {/* MapSection only on mobile */}
          <MapSection />
        </div>
    );
};

export default Contact;